import * as Types from './types';
import { actionTypes } from './constants';

export const updateButtonText = (text: string): Types.IUpdateButtonTextAction => ({
    type: actionTypes.REDUX_BUTTON_CHANGE_TEXT,
    payload: text
});
